export const portfolioWords = {
  practiceNavigation: 'Practice navigation',
  backToPractice: 'Back to practice',
  eyebrow: 'Portfolio',
  title: 'Portfolios',
  empty: 'No practices are linked yet.',
  counts: ['Not met', 'Open', 'Settled', 'Expired or due in 90 days'] as const,
  latestChecks: 'Checks in the latest binder and credentials on file',
  footprint: 'Roster and footprint on file',
  exceptions: 'Exceptions by severity',
  binder: 'Latest binder',
  noBinder: 'No binder yet',
  held: 'Assessment results are held until release.',
  csv: 'Download roster and footprint CSV',
  summary: 'Download one-page summary',
  noPortfolio: 'No portfolios are linked to your account.',
  create: 'Create portfolio',
  name: 'Organisation name',
  addPractice: 'Link a practice',
  choosePractice: 'Choose a practice',
  grant: 'Give portfolio access',
  invite: 'Invite by email',
  inviteLabel: 'Email address',
  inviteButton: 'Send invitation',
  invited: (email: string) => `Invitation sent to ${email}.`,
  granted: (email: string) => `${email} already has a VerityRx sign-in and now has portfolio access.`,
  confirmUnlink: (practice: string) => `Unlink ${practice} from this portfolio? Its people lose the portfolio view of it. This can be undone by linking it again.`,
  confirmRevoke: (email: string) => `Remove portfolio access for ${email}? They lose it on their next click.`,
  choosePerson: 'Choose a person who already signs in',
  access: 'People with portfolio access',
  revoke: 'Remove access',
  remove: 'Unlink',
  manage: 'Manage portfolio',
  noneOnFile: 'None on file',
};
